import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet";

var _dependencies = new WeakMap();

var _startTime = new WeakMap();

var _pendingDependencies = new WeakMap();

var _onCompleteListeners = new WeakMap();

var _onDependencyCompleted = new WeakMap();

var TaskTracker = /*#__PURE__*/function () {
  function TaskTracker(task) {
    var _this = this;

    _classCallCheck(this, TaskTracker);

    _defineProperty(this, "task", void 0);

    _dependencies.set(this, {
      writable: true,
      value: void 0
    });

    _startTime.set(this, {
      writable: true,
      value: void 0
    });

    _pendingDependencies.set(this, {
      writable: true,
      value: void 0
    });

    _onCompleteListeners.set(this, {
      writable: true,
      value: void 0
    });

    _onDependencyCompleted.set(this, {
      writable: true,
      value: void 0
    });

    this.task = task;

    _classPrivateFieldSet(this, _onCompleteListeners, []);

    _classPrivateFieldSet(this, _dependencies, []);

    _classPrivateFieldSet(this, _onDependencyCompleted, function (completedTask) {
      var currentTask = completedTask.task,
          success = completedTask.success;

      if (!_classPrivateFieldGet(_this, _startTime)) {
        return;
      }

      if (!success) {
        // a dependency has failed, so we must end the current task as a failure
        // end also takes care of cleanup
        _this.failed(completedTask);

        return;
      } // remove the current dependent task from the pending list


      _classPrivateFieldSet(_this, _pendingDependencies, _classPrivateFieldGet(_this, _pendingDependencies).filter(function (pendingTask) {
        return pendingTask !== currentTask;
      })); // if all pending tasks have been completed (successfully), this task should also be marked complete


      if (_classPrivateFieldGet(_this, _pendingDependencies).length === 0) {
        _this.succeeded();
      }
    });
  }

  _createClass(TaskTracker, [{
    key: "hasDependencies",
    value: function hasDependencies() {
      return _classPrivateFieldGet(this, _dependencies).length !== 0;
    }
  }, {
    key: "addCompletionListener",
    value: function addCompletionListener(listener) {
      _classPrivateFieldGet(this, _onCompleteListeners).push(listener);

      return this;
    }
  }, {
    key: "start",
    value: function start() {
      _classPrivateFieldSet(this, _startTime, performance.now());

      _classPrivateFieldSet(this, _pendingDependencies, _classPrivateFieldGet(this, _dependencies).map(function (dependency) {
        return dependency.task;
      }));

      return this;
    }
  }, {
    key: "succeeded",
    value: function succeeded() {
      this._end(true);
    }
  }, {
    key: "failed",
    value: function failed(cause, errorIdentifier) {
      this._end(false, cause, errorIdentifier);
    }
  }, {
    key: "_end",
    value: function _end(success, cause, identifier) {
      var _this2 = this;

      var startTime = _classPrivateFieldGet(this, _startTime);

      if (typeof startTime !== 'number') {
        console.warn("[".concat(this.task, "] noop: Attempted to end a task which wasn't started."));
        return;
      }

      var duration = performance.now() - startTime;
      /* Metal doesn't provide an option to pass error identifier.
       * So, utilising taskId as a error identifier */

      _classPrivateFieldGet(this, _onCompleteListeners).forEach(function (listener) {
        return listener({
          task: _this2.task,
          taskId: identifier,
          success: success,
          cause: cause,
          duration: duration
        });
      });

      this.resetState();
      return this;
    }
  }, {
    key: "resetState",
    value: function resetState() {
      _classPrivateFieldSet(this, _startTime, null);

      _classPrivateFieldSet(this, _pendingDependencies, []);

      return this;
    }
  }, {
    key: "dependsOn",
    value: function dependsOn(dependencies) {
      var _this3 = this;

      var hasNestedDependencies = dependencies.some(function (dependency) {
        return dependency.hasDependencies();
      });

      if (hasNestedDependencies) {
        throw new Error("[".concat(this.task, "] task may not depend on sub-tasks which themselves have other dependencies"));
      }

      _classPrivateFieldSet(this, _dependencies, _toConsumableArray(dependencies));

      _classPrivateFieldGet(this, _dependencies).forEach(function (dependency) {
        dependency.addCompletionListener(_classPrivateFieldGet(_this3, _onDependencyCompleted));
      });

      return this;
    }
  }]);

  return TaskTracker;
}();

export { TaskTracker as default };